import React from 'react';
import { connect } from 'react-redux';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';

import { FormikInput } from '../../../components';

const OtherRequestRejectForm = ({
  onHide,
  submitVariant,
  errors,
  touched,
  isSubmitting
}) => {
  return (
    <Form>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <Field name="otherRequest[observation]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  inputType="textarea"
                  label="Motivo del rechazo"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn" type="submit" variant={submitVariant} disabled={isSubmitting} onClick={onHide}>
          Rechazar
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = props => {
  const { id } = props.otherRequest;

  return {
    otherRequest: {
      id,
      observation: ''
    }
  };
};

const validationSchema = Yup.object().shape({
  otherRequest: Yup.object().shape({
    observation: Yup.string().required('Debes ingresar un motivo de rechazo')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(connect()(OtherRequestRejectForm));